import React from 'react';
import StandardButton from '../StandardButton/StandardButton';
import SweetAlert from 'react-bootstrap-sweetalert';
import { SweetAlertType } from 'react-bootstrap-sweetalert/dist/types';
import { t } from 'i18next';
import { capitalizeFirstLetter } from 'utils/helpers';
import StandardInput, {
  StandardInputPropsI
} from 'base/StandardInput/StandardInput';
import { UilInfoCircle } from '@iconscout/react-unicons';

interface deleteModelI {
  warning?: boolean;
  title?: string;
  type?: SweetAlertType;
  showCancel?: boolean;
  showConfirm?: boolean;
  cancelText?: string;
  okText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  showInput?: boolean;
  inputProps?: StandardInputPropsI;
}

const DeleteModel = (props: deleteModelI) => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <SweetAlert
      customClass="bg-body-emphasis"
      custom={true}
      customIcon={
        <div className="pb-3">
          <UilInfoCircle className="text-warning" height={70} width={70} />
        </div>
      }
      showCancel
      title={
        <span className="fs-6">
          {props.title || capitalizeFirstLetter(t('delete_model.delete'))}
        </span>
      }
      type={props.type}
      // input
      // inputType="textarea"
      placeholder="Write something longer..."
      customButtons={
        <React.Fragment>
          <div className="row justify-content-center w-70 ">
            {props.showCancel !== false ? (
              <div className="col-6 p-3">
                <StandardButton
                  className="w-100"
                  buttonText={
                    props.cancelText ||
                    capitalizeFirstLetter(t('delete_model.button.text_3'))
                  }
                  variant="outline-danger"
                  onClick={props.onCancel}
                />
              </div>
            ) : null}
            {props.showConfirm !== false ? (
              <div className="col-6 p-3">
                <StandardButton
                  className="w-100"
                  buttonText={
                    props.okText ||
                    capitalizeFirstLetter(t('delete_model.button.text_1'))
                  }
                  onClick={props.onConfirm}
                  disabled={props.isLoading}
                />
              </div>
            ) : null}
          </div>
        </React.Fragment>
      }
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      focusCancelBtn
    >
      {props.showInput && (
        <div className="row justify-content-center py-30">
          <div className="col-12">
            <StandardInput
              className={props.inputProps?.className || ''}
              label={props.inputProps?.label || ''}
              onChange={props.inputProps?.onChange || (() => {})}
              type={props.inputProps?.type || ''}
              value={props.inputProps?.value || ''}
              placeholder={props.inputProps?.placeholder || ''}
              showError={props.inputProps?.showError || false}
              validations={props.inputProps?.validations || []}
              {...props.inputProps}
            />
          </div>
        </div>
      )}
    </SweetAlert>
  );
};

export default DeleteModel;
